import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormsModule} from '@angular/forms';
import {DomainModule} from 'src/app/domain/domain.module';
import {InfrastructureModule} from 'src/app/infrastructure/infrastructure.module';
import {SharedComponentModule} from 'src/app/ui/shared/component/shared-component.module';
import {WebappComponentModule} from 'src/app/ui/webapp/component/webapp-component.module';
import {AdvantagesPage} from 'src/app/ui/webapp/page/unit-linked/insurance/advantages/advantages.page';
import {InsuranceRoutingModule} from 'src/app/ui/webapp/page/unit-linked/insurance/insurance.routing';
import {InsurancePage} from 'src/app/ui/webapp/page/unit-linked/insurance/insurance.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    InsuranceRoutingModule,
    SharedComponentModule,
    InfrastructureModule,
    DomainModule,
    WebappComponentModule,
  ],
  declarations: [
    InsurancePage,
    AdvantagesPage
  ]
})

export class InsuranceModule {
}
